<template>
    <Page behind-nav>
        <div class="resources-hero">
            <div class="container container--medium">
                <h1 class="resources-hero__title text-heading text-heading--md">Privacy Policy</h1>
                <p class="resources-hero__intro text-body">
                    This following document sets forth the Privacy Policy for the Savage Software Group Pty Ltd (Savage) applications Procreate and Procreate
                    Pocket (the Applications).
                </p>
            </div>
        </div>
        <div class="container container-medium">
            <div class="resources-markdown-layout resources-markdown-layout--singular">
                <h2>Procreate and your&nbsp;data</h2>
                <p>Savage does not collect or share any data when using the&nbsp;Applications.</p>
                <p>When using the Applications to create artwork, this is how your data is&nbsp;stored:</p>

                <ul>
                    <li>Your artwork, time-lapse videos, brushes and color pallets are all saved directly into your&nbsp;iPad</li>
                    <li>You are not required to login to access your data&nbsp;or&nbsp;artworks</li>
                    <li>The Applications do not connect to any Savage web servers at&nbsp;any&nbsp;time</li>
                    <li>
                        When using FacePaint, the Application (Procreate for iPad) will request access your front facing camera using the TrueDepth API. Savage
                        does not collect or store your TrueDepth data at&nbsp;any&nbsp;time
                    </li>
                    <li>
                        When using Palette capture, the Application (Procreate for iPad) will request access your camera. Savage does not collect or store your
                        Camera data at&nbsp;any&nbsp;time
                    </li>
                </ul>

                <p>Savage believes strongly in not collecting or sharing your data, period. It belongs&nbsp;to&nbsp;you.</p>
            </div>
        </div>
        <div class="resources-footer">
            <div class="container container--narrow">
                <h2 class="resources-footer__title text-heading text-heading--md">Contacting us</h2>
                <p class="resources-footer__body text-body">
                    If you have any questions about this Privacy&nbsp;Policy or would like further information, please contact us by&nbsp;email.
                </p>
                <p class="resources-footer__body text-body">
                    Savage Software Group Pty Ltd<br />
                    294 Elizabeth St, Hobart TAS 7000 Australia
                </p>
                <ProButton pill variant="primary" href="mailto:support@procreate.art">Email Support</ProButton>
            </div>
        </div>
    </Page>
</template>

<script>
import { metaTitles, metaDescriptions, metaImages } from "~/utils/meta";

export default {
    head() {
        return {
            title: this.$t("meta.privacy-policy.title"),
            meta: [
                ...metaTitles(this.$t("meta.privacy-policy.title")),
                ...metaDescriptions(this.$t("meta.privacy-policy.description")),
                ...metaImages(this.$asset(this.$t("meta.privacy-policy.image"))),
            ],
        };
    },
};
</script>
